export async function searchObject(name) {
  try {
    const res = await fetch(
      `https://lumora-backend-184l.onrender.com/api/star?name=${name}`
    );

    return await res.json();

  } catch (err) {
    console.error(err);
    return { success: false };
  }
}
